import React, { useState, useEffect } from "react";

export default function RefOpt(props) {
    const { index, referentieOpt, onSave, onDelete, onCancel, editing } = props;

    const [isEditing, setIsEditing] = useState(false);
    useEffect(() => {
    if (typeof editing === "boolean") {
        setIsEditing(editing);
    }
}, [editing]);
    const [emailOntvanger, setEmailOntvanger] = useState(
        referentieOpt.emailOntvanger
    );
    const [referenceRegex, setReferenceRegex] = useState(
        referentieOpt.referenceRegex
    );

    const bg =
        index % 2 === 0
            ? "bg-[rgba(49,169,255,0.2)] dark:bg-[rgba(49,169,255,0.2)]"
            : "bg-[rgba(101,191,255,0.5)] dark:bg-[rgba(101,191,255,0.5)]";

    const handleCancel = () => {
        setEmailOntvanger(referentieOpt.emailOntvanger);
        setReferenceRegex(referentieOpt.referenceRegex);
        setIsEditing(false);
        if(onCancel){ onCancel(); }
    };

    const handleSave = () => {
        referentieOpt.emailOntvanger = emailOntvanger;
        referentieOpt.referenceRegex = referenceRegex;
        onSave(referentieOpt);
        setIsEditing(false);
    }

    return (
        <div
            key={"referentieOpt" + index}
            className={`${bg} h-[35px] relative shrink-0 w-full flex items-center`}
        >
            <div
                aria-hidden="true"
                className="absolute border border-[rgba(0,0,0,0.7)] border-solid inset-0 pointer-events-none"
            />

            <div className="flex flex-row items-center size-full px-[10px] gap-[10px]">
                {isEditing ? (
                    <>
                        <input className="dark:text-black flex-1 mr-2 px-2 py-1 text-[14px] border rounded" value={emailOntvanger} onChange={(e) => setEmailOntvanger(e.target.value)}
                        />
                        <input className="dark:text-black flex-1 mr-2 px-2 py-1 text-[14px] border rounded" value={referenceRegex} onChange={(e) => setReferenceRegex(e.target.value)}
                        />
                        <button onClick={handleSave} className="px-2 py-1 text-sm bg-green-500 text-white rounded mr-1 border border-black"
                        >
                            💾
                        </button>
                        <button onClick={handleCancel} className="px-2 py-1 text-sm bg-gray-400 text-white rounded border border-black"
                        >
                            ↩
                        </button>
                    </>
                ) : (
                    <>
                        <div className="flex-1">
                            <p className="leading-[1.45] text-left text-[16px]">
                                {emailOntvanger}
                            </p>
                        </div>
                        <div className="flex-1">
                            <p className="leading-[1.45] text-left text-[16px]">
                                {referenceRegex}
                            </p>
                        </div>
                        <button onClick={() => setIsEditing(true)} className="px-2 py-1 text-sm bg-blue-500 text-white rounded border border-black"
                        >
                            ✏️
                        </button>
                        <button onClick={() => onDelete(referentieOpt.id)} className="px-2 py-1 text-sm bg-blue-500 text-white rounded border border-black">
                            ❌
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
